var _rect, _line, _line2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDesktopPreviewIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 4,
    width: 18,
    height: 12,
    rx: 1
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 16,
    x2: 12,
    y2: 20
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 8,
    y1: 20,
    x2: 16,
    y2: 20
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDesktopPreviewIcon);
export default __webpack_public_path__ + "static/media/desktop-preview-icon.f9a69763a6ead7cbc88a4d8470654a24.svg";
export { ForwardRef as ReactComponent };